import { render, staticRenderFns } from "./LoginDetailsPupils.vue?vue&type=template&id=0ac84d7e&"
import script from "./LoginDetailsPupils.vue?vue&type=script&lang=js&"
export * from "./LoginDetailsPupils.vue?vue&type=script&lang=js&"
import style0 from "./LoginDetailsPupils.vue?vue&type=style&index=0&id=0ac84d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports